import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { RedirectUrl } from '../action/auth/save-redirect-url';
import { setToken } from '../action/auth/set-token';
import { userSelector } from '../reducers/current-user-selectors';

type InputProps = {
  service: string;
  code: string;
};

const mapStateToProps = (state: any) => ({
  user: userSelector(state),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    setToken: (username: string) => dispatch(setToken(ownProps.service, ownProps.code, username)),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = InputProps & StateProps & DispatchProps;

class AuthorizeServicePage extends React.PureComponent<Props> {
  componentDidMount() {
    // If we hit an error here it'll crash the app
    this.setTokenAndRedirect();
  }

  setTokenAndRedirect = async () => {
    const { user, actions } = this.props;
    if (user && user.username) {
      await actions.setToken(user.username);
    }
    RedirectUrl.navigateToRedirectUrl();
  };

  render() {
    return null;
  }
}

export const AuthorizeService = connect(mapStateToProps, mapDispatchToProps)(AuthorizeServicePage);
